module.exports = __webpack_public_path__ + "static/img-4-3993d04e1ff8b0a7b396c84b5e5dccfc.jpeg";